import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class FeatureTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "numberColumn", title: "#" },
        { name: "componentColumn", title: "Komponente" },
        { name: "functionColumn", title: "Funktion" },
      ],
      rows: [
        { numberColumn: '01', componentColumn: 'Mounting Plate', functionColumn: 'For Wall or Ceiling Installation' },
        { numberColumn: '02', componentColumn: 'Bracket', functionColumn: 'Sealing bracket for the main camera body' },
        { numberColumn: '03', componentColumn: 'Photosensor', functionColumn: 'Fotodiode für den Dämmerungsschalter' },
        { numberColumn: '04', componentColumn: 'Infrarot LEDs', functionColumn: 'For Night vision - 12 IR-LEDs ( @ 850nm)' },
        { numberColumn: '05', componentColumn: 'Objektiv', functionColumn: 'Wide-angle (focal length: 4.3mm / field of view: approx. 90º dia.)' },
        { numberColumn: '06', componentColumn: 'PIR Sensor', functionColumn: 'Integrated passive infrared (PIR) motion detector' },
        { numberColumn: '07', componentColumn: 'Mikrofon', functionColumn: 'For noise detection / audio rec.' },
        { numberColumn: '08', componentColumn: 'Micro SD Card', functionColumn: 'Slot for MicroSD/SDXC cards (max. 128GB - 16GB included) - inside the camera' },
        { numberColumn: '09', componentColumn: 'Reset', functionColumn: 'Press 15-20 seconds for reset' },
        { numberColumn: '10', componentColumn: 'Network LED', functionColumn: 'Off: No Power / No signal, Flashing: Network Signal' },
        { numberColumn: '11', componentColumn: 'Netzwerkanschluss', functionColumn: 'RJ45 LAN port / connector for Cat5e LAN cable or higher' },
        { numberColumn: '12', componentColumn: 'Netzteilanschluss', functionColumn: 'For included 12V / 1A power supply' },
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

FeatureTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(FeatureTable)

// import React from 'react'
// import {Table, Column, Cell} from 'fixed-data-table-2'
// import '../../../../assets/styles/data_tables/fixed-data-table.css'

// const numberRow = [
//   '01',
//   '02',
//   '03',
//   '04',
//   '05',
//   '06',
//   '07',
//   '08',
//   '09',
//   '10',
//   '11',
//   '12'
// ];

// const componentRow = [
//   'Mounting Plate',
//   'Bracket',
//   'Photosensor',
//   'Infrared LEDs',
//   'Lense',
//   'PIR Sensor',
//   'Microphone',
//   'Micro SD Card',
//   'Reset',
//   'Network LED',
//   'Network Port',
//   'Power Connector'
// ];

// const functionRow = [
//   'For Wall or Ceiling Installation',
//   'Sealing bracket for the main camera body',
//   'Fotodiode für den Dämmerungsschalter',
//   'For Night vision - 12 IR-LEDs ( @ 850nm)',
//   'Wide-angle (focal length: 4.3mm / field of view: approx. 90º dia.)',
//   'Integrated passive infrared (PIR) motion detector',
//   'For noise detection / audio rec.',
//   'Slot for MicroSD/SDXC cards (max. 128GB - 16GB included) - inside the camera',
//   'Press 15-20 seconds for reset',
//   'Off: No Power / No signal, Flashing: Network Signal',
//   'RJ45 LAN port / connector for Cat5e LAN cable or higher',
//   'For included 12V / 1A power supply'
// ];

// // Render your table
// const FeatureTable = () => {
//     return (
//       <Table
//         rowHeight={55}
//         rowsCount={numberRow.length}
//         touchScrollEnabled={true}
//         width={850}
//         maxHeight={1000}
//         headerHeight={50}>
//         <Column
//           header={<Cell>#</Cell>}
//           cell={({rowIndex, ...props}) => (
//             <Cell {...props}>
//               {numberRow[rowIndex]}
//             </Cell>
//           )}
//           flexGrow={1}
//           width={50}
//         />
//         <Column
//           header={<Cell>Component</Cell>}
//           cell={({rowIndex, ...props}) => (
//             <Cell {...props}>
//               {componentRow[rowIndex]}
//             </Cell>
//           )}
//           flexGrow={2}
//           width={250}
//         />
//         <Column
//           header={<Cell>Function</Cell>}
//           cell={({rowIndex, ...props}) => (
//             <Cell {...props}>
//               {functionRow[rowIndex]}
//             </Cell>
//           )}
//           flexGrow={3}
//           width={535}
//         />
//       </Table>
//     )
// }

// export default FeatureTable